module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338600/circle-78a34492925183eb8e63499c78f81be7.svg";